import ErrorAlert from './ErrorAlert'
export default ErrorAlert
